import {
  ConvertBaseSettingsField,
  ConvertBaseSettingsStorageMixin,
} from "@/services/storage/storage-mixins/settings-mixins/convert-base-settings-storage-mixin";

export type ConvertSettingsField = ConvertBaseSettingsField;

export class ConvertSettingsStorageMixin extends ConvertBaseSettingsStorageMixin<ConvertSettingsField> {}
